import React from 'react';

import { useApp } from '../store/AppContext';
import Toast from './feedback/Toast';

/* Bandeaux de message empilés en bas à droite de l'écran. */
export default function Toasts() {
  const { toasts } = useApp();
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-[16px] right-[16px] z-[200] flex flex-col gap-[8px] w-[380px] max-w-[calc(100vw-32px)]">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
